module.exports = __webpack_public_path__ + "img/81a1d0e.jpg";